var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h5',[_vm._v("Products:")]),_c('ul',[_c('li',[_c('router-link',{attrs:{"to":{name: 'privacy-policy.livestream-app'}}},[_vm._v("Livestream (iOS/Android App)")])],1),_c('li',[_c('router-link',{attrs:{"to":{name: 'privacy-policy.livestream-iframe'}}},[_vm._v("Livestream (Iframe)")])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }